import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaYoutubeSquare,
  FaLinkedin,
} from "react-icons/fa";

import LogoImage from "../../images/LandingPageImage/Isancharr.svg";

const socialLinks = {
  youtube: "https://www.youtube.com/@Anlookofficial",
  insta: "https://www.instagram.com/anlookofficial/",
  facebook: "https://www.facebook.com/anlookfb/",
  linkedin: "https://www.linkedin.com/company/anlook-official/",
};

export default function Footer() {
  return (
    <footer className="bg-gray-100 font-inter">
      <div className="mx-4 sm:mx-8 md:mx-12 lg:mx-24 xl:mx-40">
        <div className="flex flex-col lg:flex-row justify-between gap-8 pt-10">
          <div className="flex flex-col flex-1 max-w-7xl">
            <img
              src={LogoImage}
              width="150"
              alt="Isancharr"
              className="h-auto"
            />
            <div className="py-4 text-text-secondary leading-relaxed text-sm ">
              At Isancharr, we empower brands with personalized conversation
              services, delivering seamless experiences that drive growth and
              build stronger customer relationships.
            </div>
          </div>

          <div className="flex items-center lg:items-end lg:justify-end gap-4">
            <a
              href={socialLinks.insta}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-heading-blue hover:text-pink-600 transition-colors"
            >
              <FaInstagramSquare size={24} />
            </a>
            <a
              href={socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-heading-blue hover:text-blue-600 transition-colors"
            >
              <FaFacebookSquare size={24} />
            </a>
            <a
              href={socialLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-heading-blue hover:text-red-600 transition-colors"
            >
              <FaYoutubeSquare size={24} />
            </a>
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-heading-blue hover:text-blue-700 transition-colors"
            >
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>

        <hr className="border-t border-slate-300 my-5 w-full" />

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pb-6 text-text-secondary">
          <div className="text-base">
            Isancharr © 2025. All rights reserved.
          </div>

          <div className="flex gap-8">
            <Link
              to="/privacy"
              className="text-base hover:text-slate-900 transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms&conditions"
              className="text-base hover:text-slate-900 transition-colors"
            >
              Terms & Condition
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
